import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TagsListControl } from "../home/controls/TagsListControl";
import { ApiDataAccess } from "../../common/ApiDataAccess";
import { SettingsContext } from "../../../infrastructure/SettingsContext";
import { LatestArticleRow } from "../home/LatestArticleRow";
import { Cache } from "../../common/Cache";
import { Logger } from "../../../infrastructure/Logger";

export const ArticlesByTagView = () => {
    const dataAccess = new ApiDataAccess("/api/articles");
    const tagDataAccess = new ApiDataAccess("/api/tags");
    const [items, setItems] = useState(null);
    const { tagId } = useParams();
    const { settings } = useContext(SettingsContext);
    const navigate = useNavigate();
    const [publishItem, setPublishItem] = useState(null);
    const cache = new Cache("tag-list", 30);
    const [allTags, setAllTags] = useState([]);
    // constructor(props) {
    //     super(props);
    //     this.dataAccess = new ApiDataAccess("/api/articles");
    //     this.state = {
    //         items: null
    //     };

    //     this.onClick = this.onClick.bind(this);
    // }
    useEffect(() => {
        console.log("!!load useeffect!", settings);
        cache
            .getOrAdd("allTags" + Math.random(), function (key) {
                return new Promise(function (resolve, reject) {
                    console.log("debug: fetch all tags");
                    tagDataAccess.get(
                        "/",
                        (data) => {
                            console.log("all tags loaded", data);
                            resolve(data);
                        },
                        (err) => {
                            Logger.writeError(err);
                            reject(err);
                        }
                    );
                });
            })
            .then((data) => {
                setAllTags(data);
            });
    }, []);

    useEffect(() => {
        var url = "/tag/" + tagId + "/pageSize/10000/0";

        console.log("load article by tag");
        dataAccess.get(
            url,
            (data) => {
                console.log(data);
                setItems(data.items ? data.items : []);
            },
            (error) => {
                //Alerts.showError('Something went wrong. Please try again.');
                //alerts.addMessage("Something went wrong. Please try your request again.");
                //TODO: notify
            }
        );
    }, [tagId]);

    // componentDidMount() {
    //     var self = this;
    //     var tagId = this.props.param_0;
    //     var url = '/tag/' + tagId + '/pageSize/10000/0';

    //     this.dataAccess.get(
    //         url,
    //         data => {
    //             console.log(data);
    //             self.setState({
    //                 items: data.items ? data.items : new Array()
    //             });
    //         },
    //         error => {
    //             Alerts.showError('Something went wrong. Please try again.');
    //         });
    // }

    const onClick = (item) => {
        var url = item.urlVersion <= 0 ? item.url : item.url + "-" + item.urlVersion;
        //Router.setRoute('/article/' + url);
        navigate(`/article/${url}`);
    };

    const getFormattedDate = (item) => {
        var date = new Date(Date.parse(item.createDate));
        return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    };

    const getUrl = (item) => {
        var protocol = window.location.protocol;
        var port = window.location.port == 80 ? "" : ":" + window.location.port;

        var host = window.location.hostname;
        var url = item.urlVersion <= 0 ? item.url : item.url + "-" + item.urlVersion;
        return protocol + "//" + host + port + "/article/" + url;
    };

    const onClickPublish = (item) => {
        console.log(item);
        var id = item.id;
        var url = "/" + id + "/publish";

        // return new Promise(function (resolve) {
        //     Confirmation.show(
        //         "Publish Article",
        //         " Are you sure that you want to publish this article to a different environment?",
        //         () => {
        //             dataAccess.post(
        //                 url,
        //                 item,
        //                 (data) => {
        //                     console.log(data);
        //                 },

        //                 (error) => {
        //                     //Alerts.showError("Something went wrong. Please try again.");
        //                     alerts.addMessage("Something went wrong. Please try your request again.");
        //                 }
        //             );
        //             resolve(true);
        //         }
        //     );
        // });
    };

    const onTagClick = (tag) => {
        //Router.setRoute('/tags/' + tag.id + '/articles');
        console.log("navigate to tag", tag);
        navigate(`/tags/${tag.id}/articles`);
    };

    return (
        <div>
            <h2>Articles by Tag</h2>
            <div className="search-results">
                {
                    items &&
                        items.length > 0 &&
                        items.map((item, index) => {
                            return (
                                <LatestArticleRow
                                    key={`row-${index}`}
                                    item={item}
                                    setPublishItem={setPublishItem}
                                    onClick={onClick}
                                    config={settings}
                                />
                            );
                        })

                    // <div>
                    //     {items.map((item, index) => {
                    //         return (
                    //             <div>
                    //                 <div key={`article_tag_${index}`} className="row">
                    //                     <div
                    //                         className="col-xs-12 col-md-12 clickable title color-blue"
                    //                         onClick={() => onClick(item)}
                    //                     >
                    //                         {item.name}
                    //                     </div>
                    //                     <div className="col-xs-12 col-md-12 clickable url" onClick={() => onClick(item)}>
                    //                         {getUrl(item)}
                    //                     </div>
                    //                     <div className="col-10" onClick={() => onClick(item)}>
                    //                         {"from " + item.createUser + " on " + getFormattedDate(item)}{" "}
                    //                         <span className="glyphicon glyphicon-user"></span> {item.views}
                    //                     </div>

                    //                     {settings && settings.PUBLISH_ENABLED && (
                    //                         <div
                    //                             className="col-1 btn btn-primary btn-sm"
                    //                             onClick={() => onClickPublish(item)}
                    //                         >
                    //                             Publish
                    //                         </div>
                    //                     )}
                    //                 </div>
                    //             </div>
                    //         );
                    //     })}
                    // </div>
                }

                {items && items.length === 0 && (
                    <div>
                        <p>I could not find any articles related to this tag.</p>
                    </div>
                )}
            </div>

            <h4>Popular Categories</h4>
            <TagsListControl tags={allTags} onTagClick={onTagClick} />
        </div>
    );
};
